import { sendPasswordResetEmail } from "firebase/auth";
import {
  initFirebase,
  clearFirebaseLocalStorage,
} from "@core/services/api/firebase";

type Args = {
  email: string;
  onError?: () => void;
};

export async function sendPasswordReset({ email, onError }: Args) {
  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    const result = await sendPasswordResetEmail(auth, email, {
      url: `${window.location.origin}/reset-password`,
      handleCodeInApp: true,
    });

    return result;
  } catch (error) {
    clearFirebaseLocalStorage();

    onError?.();

    throw error;
  }
}

export default sendPasswordReset;

